// extracted by mini-css-extract-plugin
export default {"tableRow":"areaList_tableRow__7GG13","tableCell":"areaList_tableCell__da7ti"};